import React, { Component } from 'react';
import ClientPageBackButton from "./../ClientPageBackButton";
import ScrollToComponent from "./../ScrollToComponent";

import EPNaslovna from '../../images/ep-first.jpg';
import EPauti from '../../images/ep-auti.jpg';

var EPNaslovnaImg = {
	backgroundPosition: "center center",
	backgroundSize: "cover",
	height: "100vh",
	backgroundImage: `url(${EPNaslovna})`,
	marginTop: '0'
};

var AutiNaslovnaImg = {
	backgroundPosition: "center center",
	backgroundSize: "cover",
	backgroundImage: `url(${EPauti})`,
	marginTop: '0'
};

export default class EuroPetrolPage extends Component {


	scrollNodes = [
		'#section1',
		'#section2',
		'#section3',
		'#section4',
		'#section5',
		'#section6',
		'#section7',
		'#section8',
		'#section9',
		'#section10',
		'#section11'
	];

	render () {
		return (
			<div className="smart-page">
				<ClientPageBackButton parentThis={this} currentSlideGroup={1} />
				<ScrollToComponent scrollNodes={this.scrollNodes}/>

				<div className="main-image-background" style={EPNaslovnaImg}>
				</div>

				<section id="section1" className="full-one ep-grey-background">
					<div className="cont flex1">
						<div className="ep-box-one">
							<p className="first-text brown">TV PRODUCTION</p>
							<p className="white text top-padding">Supreme quality, immaculate service, consumer care, innovativeness and all that capped off with a significant jubilee – 20 years of successful work. Euro Petrol entrusted the Smart team with scripting and producing their entire latest TV commercial.</p>
							<p className="white text bottom-padding">The whole media buying, primarily when it comes to advertising on television, was entrusted to Smart Agency, both on largest TV stations with national coverage and most popular sport cable cannels which we cooperate with as partners.</p>
							<img className="image-position petrol" src="/img/logo-ep.png" alt="euro petrol logo smart agency"/>
						</div>
						<div className="ep-center">
                            <iframe width="760" height="428" typeof="text/html" frameBorder="0" allowFullScreen
                                    src="https://www.youtube.com/embed/_p3jyq3dQww"/>
						</div>
					</div>
				</section>

				<div id="section2" className="background-image" style={AutiNaslovnaImg}></div>

				<section id="section3" className="full-three clearfix">
					<div className="cont flex1">
						<div className="left-ep">
							<p className="first-text green">STRENGTH IS IN QUALITY</p>
						</div>
						<div className="right-ep"><p className="green text top-padding">When, first of all, client provides supreme quality of its products and services, it demands the same from its agency too. We grow and improve jointly through longstanding cooperation..</p></div>
					</div>
				</section>

				<section id="section4" className="full-four">
					<div className="cont">
						<p className="first-text grey">LION GROUP</p>
						<div className="padding-0 top-20 icons flex1">
							<div className="client center-992"><a href=""><img src="img/lion-ep.png" alt="euro petrol smart agency"/></a></div>
							<div className="client center-992"><a href=""><img src="img/therm-ep.png" alt="euro petrol smart agency"/></a></div>
							<div className="client center-992"><a href=""><img src="img/trans-ep.png" alt="euro petrol smart agency"/></a></div>
							<div className="client center-992"><a href=""><img src="img/euro-real-estate.png" alt="euro petrol smart agency"/></a>
							</div>
							<div className="client center-992"><a href=""><img src="img/lioncaffe-ep.png" alt="euro petrol smart agency"/></a></div>
							<div className="client center-992"><a href=""><img src="img/eurogarni-ep.png" alt="euro petrol smart agency"/></a></div>
						</div>
						<div className="clearfix"></div>
					</div>
				</section>

				<div className="cleardiv"></div>

				<section id="section5" className="image-full relative sec-over">
					<img src="/img/ep-memo.png" alt="euro petrol smart agency"/>
					<p className="absolute-text grey text top-padding" style={{marginTop: '90px'}}>The LION group, a part of which is Euro Petrol, takes up significant place in the Smart portfolio. The Smart creative team completed the visual identity for all members of the LION group. We were also assigned with branding their car park.</p>
				</section>

				<section id="section6" className="image-full minus-14"><img src="/img/girl-ep.jpg" alt="euro petrol smart agency"/></section>

				<section id="section7" className="top-20 relative-pos">
					<img className="right img-992" src="/img/ep-bilbord.jpg" alt="euro petrol smart agency"/>
					<div className="cleardiv"></div>
				</section>

				<section id="section8" className="full-nine">
					<div className="cont">
						<img className="img-left clearfix img-992" src="/img/ep-snaga.jpg" alt="euro petrol smart agency"/>
						<img id="section9" className="img-right img-right-1 clearfix img-992" src="/img/ep-energija.jpg" alt="euro petrol smart agency"/>
						<img id="section10" className="img-left clearfix img-992" src="/img/ep-oslonac.jpg" alt="euro petrol smart agency"/>
						<img id="section11" className="img-right clearfix img-992" src="/img/ep-izolacija.jpg" alt="euro petrol smart agency"/>
					</div>
				</section>

			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/English/EuroPetrolEnglishPage.js